export enum ApiLanguage {
  at = 'AT',
  de = 'DE',
  en = 'EN'
}
